import { useMutation } from "react-query";
import { updateEmployeeTitle } from "../../../../../actions/Utilities/EmployeeTitle";

const useEditEmployeeTitle = () => {
  return useMutation(updateEmployeeTitle);
}

export default useEditEmployeeTitle